module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "container",
    attrs: {
      "id": "login"
    }
  }, [_h('div', {
    staticClass: "form_main"
  }, [_h('div', {
    staticClass: "form"
  }, [_h('p', {
    staticClass: "tit_form"
  }, ["登　录"]), " ", _h('div', {
    staticClass: "form-group"
  }, [_h('label', ["昵　　称:"]), " ", _h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "请输入您的用户名"
    },
    domProps: {
      "value": _vm._s(_vm.name)
    },
    on: {
      "focus": _vm.clearMsg,
      "keyup": function($event) {
        if ($event.keyCode !== 13) { return; }
        _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), " ", _h('div', {
    staticClass: "form-group"
  }, [_h('label', ["密　　码:"]), " ", _h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "请输入您的密码"
    },
    domProps: {
      "value": _vm._s(_vm.pwd)
    },
    on: {
      "focus": _vm.clearMsg,
      "keyup": function($event) {
        if ($event.keyCode !== 13) { return; }
        _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pwd = $event.target.value
      }
    }
  })]), " ", _h('p', {
    staticClass: "message"
  }, [_vm._s(_vm.msg)]), " ", _h('p', {
    staticClass: "tit_form"
  }), " ", _h('div', {
    staticClass: "text-center"
  }, [_h('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.login
    }
  }, ["登录"])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9cd13f96!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login.vue
// module id = 45
// module chunks = 1